import sortplet from '@/data/sortpledt_kryds_2013.json';

const BaseUrl =
  'https://webkort.herning.dk/wfs/ows?service=wfs&version=2.0.0&request=GetFeature&outputformat=json&srsname=epsg:4326&typeNames=spatialsuite:';

export default function getHerningWfsData() {
  return Promise.all([fetch(`${BaseUrl}sortplet_kryds_2013`)])
    .then(response => {
      return Promise.all([response[0].json()]);
    })
    .then(response => {
      return {
        punkter: {
          signalanlaeg: null,
          sortplet_kryds_2013: response[0],
        },
        linjer: {
          trafikfarlige_skoleveje: null,
        },
      };
    })
    .catch(err => {
      console.log(err);
      return {
        punkter: {
          signalanlaeg: null,
          sortplet_kryds_2013: sortplet,
        },
        linjer: {
          trafikfarlige_skoleveje: null,
        },
      };
    });
}
